import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from './login/login.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { ProjectComponent } from './project/project.component';
import { ConfirmationdialogueComponent } from './confirmationdialogue/confirmationdialogue.component';
import { NewProjectComponent } from './new-project/new-project.component';
import { ProgramSettingsComponent } from './program-settings/program-settings.component';
import { CustomerInfoComponent } from './project/customer-info/customer-info.component';
import { SiteInfoComponent } from './project/site-info/site-info.component';
import { ContaminationComponent } from './project/contamination/contamination.component';
import { SolutionComponent } from './project/solution/solution.component';
import { ResultComponent } from './project/result/result.component';
import { ReportsComponent } from './project/reports/reports.component';
//import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AstmComponent } from './project/astm/astm.component';
import { AstmResultComponent } from './project/astm-result/astm-result.component';
import { AstmReportComponent } from './project/astm-report/astm-report.component';
import { DropFileDirective } from './home/drop-file.directive';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    UserInfoComponent,
    HeaderComponent,
    HomeComponent,
    ProjectComponent,
    ConfirmationdialogueComponent,
    NewProjectComponent,
    ProgramSettingsComponent,
    CustomerInfoComponent,
    SiteInfoComponent,
    ContaminationComponent,
    SolutionComponent,
    ResultComponent,
    ReportsComponent,
    AstmComponent,
    AstmResultComponent,
    AstmReportComponent,
    DropFileDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    NgbModule,
  ],
  providers: [LoginComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
